(function ($) {

    let $header, $wpAdminBar, lastScollPosition;
    $(document).ready(onResize);
    $(document).on('click', '.woocommerce-store-notice__dismiss-link', onResize);
    $(window).on('resize', onResize);

    $(window).on('scroll', onScroll);

    function onResize() {
        $wpAdminBar = $('#wpadminbar');
        $header = $('header#masthead');
        $('body').css('padding-top', ($header.outerHeight() + ($('.current-menu-item .sub-menu, .current-menu-parent .sub-menu').outerHeight() || 0)) + 'px');

        if (!$wpAdminBar.length) return false;
        $header.css('top', $wpAdminBar.height() + 'px');
    }

    function onScroll() {

        const top = $(window).scrollTop();
        if (!$header) return false;

        $header.css('top', ($wpAdminBar.height() || 0) + 'px');

        if (top > lastScollPosition && top > $header.height()) {
            $('body').addClass('scrolled-down');
            $header.css('transform', 'translateY(-150%)');
        } else {
            $('body').removeClass('scrolled-down');
            $header.css('transform', 'translateY(0)');
        }

        lastScollPosition = top;

    }

})(jQuery);
